/**
 * Client-safe registry of AI Gateway models the chat UI may use.
 *
 * Pure data — no `server-only` imports — so this can be imported from both
 * the server route handler and client components (model selector dropdown,
 * thread metadata store).
 *
 * The first entry is the default model. Order matters.
 */
export type AiModelDescriptor = {
    readonly id: string;
    readonly label: string;
    readonly description: string;
};

export const AI_MODELS = [
    {
        id: 'openai/gpt-4o-mini',
        label: 'GPT-4o mini',
        description: 'Default — fast, low-cost, reliable structured tool calls.',
    },
    {
        id: 'openai/gpt-oss-120b',
        label: 'GPT-OSS 120B',
        description: 'Open-weights — strong quality, low latency.',
    },
    {
        id: 'openai/gpt-5-nano',
        label: 'GPT-5 nano',
        description: 'Lightweight OpenAI model — quickest responses.',
    },
    {
        id: 'google/gemini-2.0-flash-lite',
        label: 'Gemini 2.0 Flash Lite',
        description: 'Google low-latency model.',
    },
    {
        id: 'anthropic/claude-sonnet-4-6',
        label: 'Claude Sonnet 4.6',
        description: 'Anthropic — stronger reasoning, slightly slower.',
    },
] as const;

export const DEFAULT_AI_MODEL_ID: string = AI_MODELS[0]!.id;

export const AI_MODEL_IDS: ReadonlyArray<string> = AI_MODELS.map(m => m.id);

export function isValidAiModelId(value: unknown): value is string {
    return typeof value === 'string' && AI_MODEL_IDS.includes(value);
}
